// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2vtMB","info":"PatientInfo_info__HxqgL"};